import {
  createFileRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/capa/(pages)/(list)/plans')({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/capa/plans' ||
      location.pathname === '/capa/plans/'
    ) {
      throw redirect({ to: '/capa/plans/active' });
    }
  },
  component: lazyRouteComponent(
    () => import('../../../-components/PlansLayout'),
    'PlansLayout',
  ),
});
